import { useSaveFilters } from '@ais-ui/websockets';
import { SaveFilterDialog } from './SaveFilterDialog';

interface CreateFilterProps {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export function CreateFilter({ showDialog, setShowDialog }: CreateFilterProps) {
  const { mutate } = useSaveFilters();

  return (
    <SaveFilterDialog
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      action="create"
      mutate={mutate}
      error={null}
    ></SaveFilterDialog>
  );
}
